// Header Functions
// handleSubMenuPos();
topLevelMenuPos();

hideAnnouncementBar();
hiddenFeaturedImages();
// handleTransparentHeader();
// Hotspot
hotSpots();
// GSAP
stagger();
// Product Card Height Matching
// productCardHeight('.card-information-wrapper');

// Header Functions
function handleSubMenuPos() {
  document.querySelectorAll('details > ul').forEach((item) => {
    const itemParent = item.parentNode;
    // Minus 1px to help with alignment
    item.style.paddingLeft = `${itemParent.offsetLeft - 1}px`;
  });
}

function topLevelMenuPos() {
  const topLevelMenu = document.querySelector('.header-menu-wrapper');
  const subMenus = document.querySelectorAll('.header__submenu');

  subMenus.forEach((subMenu) => {
    subMenu.style.paddingLeft = `${topLevelMenu.offsetLeft}px`;
  });
}

function hiddenFeaturedImages() {
  const header = document.querySelector('#Header');
  const triggers = header.querySelectorAll(
    '.header__submenu .header__submenu .list-menu__item'
  );
  const images = gsap.utils.toArray(
    '.header__submenu .header__submenu .link-featured-image__wrapper'
  );

  images.forEach((image) => {
    gsap.set(image, {
      autoAlpha: 0,
    });
  });

  triggers.forEach((trigger) => {
    const image = trigger.nextElementSibling;

    if (image !== null) {
      trigger.addEventListener('mouseenter', () => {
        gsap.to(image, { autoAlpha: 1 });
      });

      trigger.addEventListener('mouseleave', () => {
        gsap.to(image, { autoAlpha: 0 });
      });
    }
  });
}

function hideAnnouncementBar() {
  const header = document.querySelector('#shopify-section-header');
  const announcementBar = document.querySelector('.announcement-bar') || null;

  if (announcementBar !== null) {
    const barHeight = announcementBar.clientHeight;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        gsap.to(header, { y: -`${barHeight}` });
      } else {
        gsap.to(header, { y: 0 });
      }
    });
  }
}

// Can maybe remove this
function handleTransparentHeader() {
  const headerMenu = document.querySelector('.header__inline-menu');
  const menuItems = headerMenu.querySelectorAll(
    'details:not([id^="Details-menu-drawer-menu-item"])'
  );

  menuItems.forEach((item) => {
    item.addEventListener('click', () => {
      // track active element
      const activeItem = document.querySelector('[open]');
    });
  });

  window.addEventListener('scroll', function () {
    if (window.scrollY > 10) {
      header.classList.remove('transparent-header');
      document.body.classList.add('is-scrolled-down');
    } else {
      document.body.classList.remove('is-scrolled-down');
      header.classList.add('transparent-header');
    }
  });
}

// Transparent Header Notes:
// - if sub menu is open remove the transparent-header class
// -

// Hotspots
function hotSpots() {
  let activeProduct, productToShow, activeHotspot;
  const hotspots = document.querySelectorAll('.hotspot-wrapper');
  const hotspotProducts = document.querySelectorAll('.hotspot-product');
  const hotspotAnim = gsap.timeline({ paused: true });

  // Return early if no hotspots
  if (hotspots.length === 0) return;

  activeHotspot = hotspots[0];
  activeProduct = hotspotProducts[0];

  hotspots[0].classList.add('active');
  hotspotProducts[0].classList.add('active');

  hotspots.forEach((hotspot) => {
    // Tablet Touch handler

    function handleHotspots(e) {
      const hotspotId = e.currentTarget.getAttribute('data-hotspot-id');
      productToShow = document.querySelector(
        `[data-product-id='${hotspotId}']`
      );

      if (activeProduct !== productToShow) {
        activeProduct.classList.remove('active');
      }

      activeHotspot.classList.remove('active');

      hotspot.classList.add('active');
      productToShow.classList.add('active');
      activeProduct = productToShow;
      activeHotspot = e.currentTarget;
    }

    hotspot.addEventListener('touchstart', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      handleHotspots(e);
    });

    hotspot.addEventListener('mouseenter', (e) => {
      handleHotspots(e);
    });
  });

  hotspots.forEach((el) => {
    hotspotAnim.fromTo(
      el,
      {
        autoAlpha: 0,
        y: 10,
      },
      { autoAlpha: 1, y: 0, duration: 0.85, stagger: 0.5, ease: 'power3.in' },
      '-=0.55'
    );
  });

  if (hotspots.length > 0) {
    setTimeout(() => {
      hotspotAnim.play();
    }, 2500);
  }
}

// GSAP Animation functions

function stagger() {
  const staggerElms = document.querySelectorAll('.stagger');
  const staggerElmsDown = document.querySelectorAll('.stagger--down');
  const staggerTl = gsap.timeline({ paused: true });

  staggerElmsDown.forEach((el) => {
    staggerTl.fromTo(
      el,
      {
        autoAlpha: 0,
        y: -5,
      },
      { autoAlpha: 1, y: 0, duration: 0.85, stagger: 0.1, ease: 'power3.in' },
      '-=0.55'
    );
  });

  staggerElms.forEach((el) => {
    staggerTl.fromTo(
      el,
      {
        autoAlpha: 0,
        y: 5,
      },
      { autoAlpha: 1, y: 0, duration: 0.85, stagger: 0.1, ease: 'power3.in' },
      '-=0.55'
    );
  });

  if (staggerElms.length > 0) {
    setTimeout(() => {
      staggerTl.play();
    }, 700);
  }
  if (staggerElmsDown.length > 0) {
    setTimeout(() => {
      staggerTl.play();
    }, 700);
  }
}

function fadeIn() {
  const fadeInElms = document.querySelectorAll('[data-anim="fadeIn"]');
  const staggerTl = gsap.timeline({ paused: true });

  fadeInElms.forEach((el) => {
    staggerTl.fromTo(
      el,
      {
        autoAlpha: 0,
      },
      { autoAlpha: 1, duration: 1, stagger: 0.1, ease: 'power3.in' },
      '-=0.55'
    );
  });

  if (fadeInElms.length > 0) {
    setTimeout(() => {
      staggerTl.play();
    }, 1300);
  }
}

function productCardHeight(className) {
  if (className.length === 0) return;

  let min = getMinHeight(className);
  setHeight(className, min);
}

function getMinHeight(className) {
  let min = 0;
  document.querySelectorAll(className).forEach(function (el) {
    if (el.scrollHeight > min) {
      min = el.scrollHeight;
    }
  });

  return min;
}

function setHeight(className, height) {
  document.querySelectorAll(className).forEach(function (el) {
    el.style.height = height + 'px';
  });
}

// Global Event Listeners
window.addEventListener('DOMContentLoaded', fadeIn);
window.addEventListener('resize', topLevelMenuPos);
